import styled from 'styled-components';
export const LogTitleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;
